import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MessageListComponent } from "./pages/message-list/message-list.component";
import { MessageDetailComponent } from "./pages/message-detail/message-detail.component";
import { NotificationComponent } from "./pages/notification/notification.component";
import { DirectMessagesComponent } from "./pages/direct-messages/direct-messages.component";
import { InboxComponent } from "./pages/inbox/inbox.component";
import { InboxMessageDetailComponent } from "./pages/inbox-message-detail/inbox-message-detail.component";
import { UserChatWindowComponent } from './pages/user-chat-window/user-chat-window.component';
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "messages",
    component: MessageListComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["messages"] },
  },
  {
    path: "messages/detail/:id",
    component: MessageDetailComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["messages/detail/:id"] },
  },
  {
    path: "notification",
    component: NotificationComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["notification"] },
  },
  {
    path: "direct-message",
    component: DirectMessagesComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["direct-message"] },
  },
  {
    path: "user/direct/message/:id",
    component: UserChatWindowComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["user/direct/message/:id"] },
  },
  {
    path: "inbox",
    component: InboxComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["inbox"] },
  },
  {
    path: "inbox/message/detail/:id",
    component: InboxMessageDetailComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["inbox/message/detail/:id"] },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MessageCenterRoutingModule { }
